export * from "./registerSubject.component";
